import './CRUDth.css'

function CRUDth({th}) {
  return (
    <th scope="col">{th}</th>
  )
}

export default CRUDth